// extracted by mini-css-extract-plugin
export var form = "_ct-0";